export const BOOTSTRAP_APP = 'BOOTSTRAP_APP';
